export const getPointData = () => localStorage.getItem('snowflake')
export const setPointData = (pointData) => localStorage.setItem('snowflake', pointData)

export const getMessage = () => localStorage.getItem('message')
export const setMessage = (message) => localStorage.setItem('message', message)

export const getColor = () => localStorage.getItem('color')
export const setColor = (color) => localStorage.setItem('color', color)

export const getSnowflakeViewState = () => localStorage.getItem('snowflakeViewState')
export const setSnowflakeViewState = (snowflakeViewState) => localStorage.setItem('snowflakeViewState', snowflakeViewState)

export const getAudioIsPlaying = () => localStorage.getItem('audioIsPlaying')
export const setAudioIsPlaying = (audioIsPlaying) => localStorage.setItem('audioIsPlaying', audioIsPlaying)

export const removeSnowflakeData = () => {
  localStorage.removeItem('snowflake')
  localStorage.removeItem('message')
  localStorage.removeItem('color')
  localStorage.removeItem('snowflakeViewState')
}


// WEBPACK FOOTER //
// ./src/services/applicationState.js